export const SET_OFFICIAL_STATEMENT_CONTENT = '@main/SET_OFFICIAL_STATEMENT_CONTENT' as const;
export const SET_BURNING_TRANSACTIONS = '@main/SET_BURNING_TRANSACTIONS' as const;
export const SET_BURNING_ACCOUNT = '@main/SET_BURNING_ACCOUNT' as const;
